import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch } from "react-redux";
import { updateJobPostConfidentialStatus } from "../../state/jobPostList/jobPostListSlice";

const ITEM_HEIGHT = 48;

const JobsMenuAction = ({ jobPost }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch();

  const handleConfidential = (status) => {
    dispatch(updateJobPostConfidentialStatus({ id: jobPost.id, isConfidential: status }));
    handleMenuClose();
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton size='small' aria-label="more" id="long-button" aria-controls={open ? "long-menu" : undefined} aria-expanded={open ? "true" : undefined} aria-haspopup="true" onClick={handleMenuClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "23ch",
          },
        }}
      >
        {!jobPost?.isConfidential ? (
          <MenuItem onClick={() => handleConfidential(true)}>
            Make Confidential
          </MenuItem>
        ) : (
          <MenuItem onClick={() => handleConfidential(false)}>
            Remove from Confidential
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default JobsMenuAction;
